import type { SvgIconProps } from './types';

export function ErrorInfoIcon(props: SvgIconProps) {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" {...props}>
      <circle cx="8" cy="8" r="7.2" fill="currentColor" opacity="0.15" />
      <path d="M8 4.2v4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="8" cy="11.3" r="0.9" fill="currentColor" />
    </svg>
  );
}
